export const ROLE = {
  ADMIN: "ADMIN",
  USER: "USER",
};

export const FEATURE = { USER: "User", DASHBOARD: "Dashboard" };

export const ACTION = {
  VIEW: "view",
  READ: "read",
  WRITE: "write",
  UPDATE: "update",
  DELETE: "delete",
  EXPORT: "export",
};
